
import { DiscoveryDocument } from '../phoenix/domain';
import { AuthService } from 'phoenix/services';
import * as io from 'socket.io-client';
import { IShareBaseSocket, NullShareBaseSocket, ShareBaseSocket, SocketSubject } from './sockets';
import { DiscoveryDocumentService } from 'phoenix/services/discoveryDocumentService';
import { PhoenixToggleService } from 'phoenix/services/phoenixToggleService';
import { SocketFactory } from './socket-factory';

const anyFeature = '*';
// How many times socket.io attempts to connect to the server before
// giving up
const numReconnectionAttempts = 10;

/**
 * A service that takes care of creating new sockets by handling how to connect, authentication,
 * and how to join socket.io rooms.
 */
export class SocketIoSocketFactory implements SocketFactory {
    public static readonly $inject = [
        '$rootScope',
        '$q',
        'pxAuthService',
        'pxDiscoveryDocumentService',
        'pxPhoenixToggleService'
    ];

    private readonly url: string;
    private readonly path: string;
    private enabled: boolean;

    constructor(
        private readonly $rootScope: ng.IRootScopeService,
        private readonly $q: ng.IQService,
        private readonly auth: AuthService,
        private readonly discovery: DiscoveryDocumentService,
        private readonly featureService: PhoenixToggleService
    ) {
    }

    public create(forFeature: string = anyFeature): ng.IPromise<IShareBaseSocket> {

        let p: ng.IPromise<boolean> = forFeature === anyFeature ?
            this.$q.resolve(true) : this.featureService.isEnabled(forFeature)
                .catch(() => false);
        
        return p
            .then(enabled => enabled ? this.discovery.get() : { })
            .then((doc: any) => {
                let socket: IShareBaseSocket;

                if (doc.PushServer && doc.PushServer.Url) {
                    let opts: SocketIOClient.ConnectOpts = {
                        query: `ns=${this.getNamespace()}`,
                        reconnectionAttempts: numReconnectionAttempts
                    };

                    if (doc.PushServer.Path) {
                        opts.path = doc.PushServer.Path;
                    }

                    let url = this.getUrl(doc);
                    socket = new ShareBaseSocket(this.$rootScope, io(url, opts), {
                        userId: this.auth.userId,
                        userName: this.auth.user.UserName,
                        emailAddress: this.auth.user.EmailAddress,
                    }, this.auth.token.value);
                } else {
                    socket = new NullShareBaseSocket();
                }
                
                return socket;
            });
    }

    private getUrl(doc: DiscoveryDocument) {
        let url = doc.PushServer.Url;
        if (url) {
            if (url.charAt(url.length - 1) === '/') {
                url = url.slice(0, -1);
            }
            
            
            url += `/${this.getNamespace()}`;
        }

        return url;
    }

    private getNamespace() {
        return `deployment-${this.auth.deploymentId}`;
    }
}


// WEBPACK FOOTER //
// ./src/real-time/socketio-socket-factory.ts